export default __webpack_public_path__ + "static/fa-light-300-bf9fa6dd4018ae1b9e82dab7f97dca0e.svg";